export const emailRegex = RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const regexRfc = RegExp(/^[a-zA-Z]{3,4}\d{6}[a-zA-Z0-9]{3}$/);
export const regexRazonSocial = RegExp(/^[0-9a-zA-ZáÁéÉíÍóÓúÚñÑüÜ.,#& \-\w]*$/);

export const integerRegex = RegExp(/^[0-9\b]+$/);

export const inputNumericoEnteros = (evt) => {
  if (
    evt.key === "e" ||
    evt.key === "E" ||
    evt.key === "." ||
    evt.key === "+" ||
    evt.key === "-"
  ) {
    evt.preventDefault();
  }
};
